const METHODS = [
  { id: 'p2p', label: 'Pago Móvil', sub: 'P2P' },
  { id: 'immediate_debit', label: 'Débito', sub: 'Inmediato' },
  { id: 'bcv_transfer', label: 'Transferencia', sub: 'BCV' },
  { id: 'c2p', label: 'C2P', sub: 'Cobro Directo' },
  { id: 'domiciliacion', label: 'Domiciliación', sub: 'Cargo a cuenta' },
];

export default function PaymentMethodSelector({ selectedMethod, onSelect, allowedMethods }) {
  const domEnabled = Array.isArray(allowedMethods) && allowedMethods.includes('domiciliacion');
  const list = domEnabled
    ? METHODS.filter((m) => allowedMethods.includes(m.id))
    : METHODS.filter((m) => m.id !== 'domiciliacion');
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6" data-testid="payment-method-selector">
      {list.map((m) => {
        const active = selectedMethod === m.id;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onSelect(m.id)}
            data-testid={`method-${m.id}`}
            className={`p-4 border-2 rounded-xl transition-all ${
              active
                ? 'border-blue-500 bg-blue-50 shadow-md'
                : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
            }`}
          >
            <p
              className="font-semibold text-sm"
              style={{ color: active ? '#003594' : '#051C2C' }}
            >
              {m.label}
            </p>
            <p className="text-xs text-gray-600">{m.sub}</p>
          </button>
        );
      })}
    </div>
  );
}
